module.exports = __webpack_public_path__ + "img/Katarina_acc_12.df673d69.jpg";